















import ZenButton from '@reciprocity/button';
import { uniqueId } from 'lodash';
import { GridItemType, ComponentTypes, DEFAULT_GRID_ITEMS_SETTINGS } from '../model';

export default {
  name: 'GridItemBuilder',
  components: {
    ZenButton,
  },
  props: {
    columns: {
      required: true,
      type: Number,
      default: Infinity,
    },
  },
  data() {
    return {
      ComponentTypes,
    };
  },
  methods: {
    newGridItem(itemType: string) {
      const defaultSettings = DEFAULT_GRID_ITEMS_SETTINGS[itemType];
      const item: GridItemType = {
        i: uniqueId(itemType),
        componentType: itemType,
        title: defaultSettings.title,
        x: defaultSettings.x,
        y: defaultSettings.y,
        h: defaultSettings.h,
        w: this.columns,
        isResizable: defaultSettings.isResizable,
        isDraggable: defaultSettings.isDraggable,
      };
      this.$emit('newItem', item);
    },
  },
};
